import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
    fetchSingleCastle, // Fetch full castle details
    fetchCastleDescription,
    fetchCastleQuestions,
    fetchCastleImages,
  } from "../../API/castles";
  import Text from "../../components/Text";
  import {
    RightWrapper,
    InfoWrapper,
    RowItems,
    Icon,
    CastlePageWrapper,
    LeftWrapper,
    ImageGallery,
    TextWrapper,
    Close,
    ContentWrapper,
    DescriptionWrapper,
    StyledSimpleBar,
    DifficultyWrapper,
    ButtonsWrapper,
    DifficultyButton,
    UpperWrapper,
    YellowBackground,
    ButtonItemWrapper,
    PointsInfoWrapper,
    Points,
    Bullets,
    Bullet,
    Magnifier,
    Spinner,
    CloseContainer, 
    CloseXIcon, 
    CloseBackground
  } from "./CastleDetails.style";
  import LoosingProgressModal from "../../components/Modals/LoosingProgressModal";
  import LocationIcon from "../../assets/location.svg";
  import TimeIcon from "../../assets/time.svg";
  import SwordsIcon from "../../assets/fight.svg";
  import { Overlay } from "../../components/Modals/modals.style";
  import CloseIcon from "../../assets/close-button2.png";
  import Pageside from "../../assets/page-side.png";
  import PlayImg from "../../assets/play-btn.png";
  import Audio from "../../components/Audio";
  import Button from "../../components/Button";
  import CastlePage from "../CastlePage/CastlePage"; // Import CastlePage component
  import YellowShadow from "../../assets/yellow-shadow.png";
  import MagnifierBtn from "../../assets/magnifier-btn.png";
  import YelloArrow from "../../assets/yellow-arrow.png";
  import SmallXContainer from "../../assets/smallXcontainer.svg";
import SmallX from "../../assets/smallX.svg";
  import "../../index.css";
  import { CastleAlbum } from "./CastleAlbum";
  import { API_BASE_URL } from "../../config/api"; // Make sure this is already imported
const CastleDetailsPart2 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { castleId, selectedDifficulty } = location.state || {};
  


  const [castleName, setCastleName] = useState("");
  const [castleYear, setCastleYear] = useState("");
  const [castleLocation, setCastleLocation] = useState("");
  const [castleEvents, setCastleEvents] = useState("");
  const [description, setDescription] = useState([]);
  const [showAlbum, setShowAlbum] = useState(false); // Show album
  const [images, setImages] = useState([]); // Store images from API
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const [loading, setLoading] = useState(false); // Track loading state
  const [error, setError] = useState(null); // Track any errors
  const [isLoadingImages, setIsLoadingImages] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const timestamps = [];

  useEffect(() => {
    if (!castleId) return;
    setAudioReady(false); // ✅ reset it on castle change
    const fetchCastleData = async () => {
      setLoading(true);
      setError(null);
    
      try {
        const data = await fetchSingleCastle(castleId); // This is from the backend
    
        if (data) {
          const response = await fetch("/assets/audios.json");
          const audios = await response.json();
    
          const castleAudio = audios.find(
            (entry) => parseInt(entry.castle_id) === parseInt(castleId)
          );
    
          if (castleAudio && castleAudio.audio) {
            const part1 = castleAudio.audio.part_1;
            const part2 = castleAudio.audio.part_2;
    
            if (part1 && part2) {
                sessionStorage.setItem("castle_audio_count", "2");
                sessionStorage.setItem("castle_audio_1", part1);
                sessionStorage.setItem("castle_audio_2", part2);
                sessionStorage.setItem("castle_audio_step", "2"); // ✅ correct step
                setAudioReady(true);
              }
               else if (part1) {
              sessionStorage.setItem("castle_audio_count", "1");
              sessionStorage.setItem("castle_audio_1", part1);
              sessionStorage.removeItem("castle_audio_2");
              sessionStorage.setItem("castle_audio_step", "1"); // Still part 1
              setAudioReady(true);
            } else {
              sessionStorage.setItem("castle_audio_count", "0");
              sessionStorage.removeItem("castle_audio_1");
              sessionStorage.removeItem("castle_audio_2");
              sessionStorage.removeItem("castle_audio_step");
              setAudioReady(false);
            }
            
            
          } else {
            console.warn(`⚠️ [ID ${castleId}] No audio entry found in audios.json`);
            sessionStorage.setItem("castle_audio_count", "0");
            sessionStorage.removeItem("castle_audio_1");
            sessionStorage.removeItem("castle_audio_2");
          }
    
          // Set other castle info
          setCastleName(data.castle_name || "Unknown Castle");
          setCastleYear(data.year || "Unknown Year");
          setCastleLocation(data.location || "Unknown Location");
          setCastleEvents(data.events || "No historical events available");
          if (data.intro_text?.part_2) {
            setDescription(data.intro_text.part_2);
          } else {
            setDescription("Δεν υπάρχει διαθέσιμη εισαγωγή.");
          }
          
        } else {
          setError("No castle data found.");
        }
      } catch (err) {
        setError("Failed to load castle data.");
        console.error("🚨 Error fetching castle data:", err);
      } finally {
        setLoading(false);
      }
    };
    
    
    
    

    const fetchImages = async () => {
      setIsLoadingImages(true);
      try {
        const imagesData = await fetchCastleImages(castleId);
        // console.log("✅ Images Fetched:", imagesData);

        if (imagesData && imagesData.length > 0) {
          // ✅ Convert relative paths to full URLs
          setImages(imagesData.map((img) => `${API_BASE_URL}/${img}`));
        } else {
          setImages([]);
        }
      } catch (error) {
        setImages([]);
      } finally {
        setIsLoadingImages(false);
      }
    };

    fetchCastleData();
    fetchImages(); // ✅ Fetch images separately
  }, [castleId]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setVisible(true);
  //   }, 1500);

  //   return () => clearTimeout(timer);
  // }, []);

  function handleDataFromChild(timestampData) {
    timestamps.push(timestampData);
  }

  function calculateAudioPoints() {
    // console.log(timestamps + "\n-----\n");
    const timestampsSortedArray = timestamps.sort((a, b) => a[0] - b[0]);
    // console.log(timestampsSortedArray);

    const timestampsCleaned = [];

    timestampsSortedArray.forEach((currentTimestamp) => {
      if (
        timestampsCleaned.length === 0 ||
        timestampsCleaned[timestampsCleaned.length - 1][1] < currentTimestamp[0]
      ) {
        timestampsCleaned.push(currentTimestamp);
      } else {
        timestampsCleaned[timestampsCleaned.length - 1][1] = Math.max(
          timestampsCleaned[timestampsCleaned.length - 1][1],
          currentTimestamp[1]
        );
      }
    });

    console.log(timestampsCleaned);
  }


  return (
    <>
      <Overlay />
      {showAlbum && (
        <CastleAlbum
          images={images}
          handleClose={setShowAlbum}
          open={showAlbum}
        />
      )}
      <CastlePageWrapper className="part-2">
        <LeftWrapper>
          <div style={{ height: "100%", position: "relative" }}>
            <Magnifier src={MagnifierBtn} onClick={() => setShowAlbum(true)} />

            {/* ✅ Show Spinner while loading images */}
            {isLoadingImages ? (
              <Spinner />
            ) : images.length > 0 ? (
              <>
                <ImageGallery src={images[currentIndex]} />
                {/* ✅ Navigation Buttons */}
                {images.length > 1 && (
                  <>
                    <button
                      onClick={() =>
                        setCurrentIndex((prevIndex) =>
                          prevIndex === 0 ? images.length - 1 : prevIndex - 1
                        )
                      }
                      style={{
                        position: "absolute",
                        left: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <img src={YelloArrow} alt="" />
                    </button>

                    <button
                      onClick={() =>
                        setCurrentIndex((prevIndex) =>
                          prevIndex === images.length - 1 ? 0 : prevIndex + 1
                        )
                      }
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={YelloArrow}
                        style={{ transform: "rotate(180deg)" }}
                        alt=""
                      />
                    </button>
                  </>
                )}

                {/* ✅ Image navigation bullets */}
                <Bullets
                // style={{
                //   display: "grid",
                //   gridTemplateColumns: `repeat(${Math.min(
                //     images.length,
                //     5
                //   )}, auto)`,
                //   gap: "8px",
                //   justifyContent: "center",
                // }}
                >
                  {images.map((_, index) => (
                    <Bullet
                      key={index}
                      onClick={() => setCurrentIndex(index)}
                      style={{
                        backgroundColor:
                          index === currentIndex
                            ? "#D55E3A"
                            : "var(--highlight)",
                      }}
                    />
                  ))}
                </Bullets>
              </>
            ) : (
              <Text fontSize="16px" color="#FFF">
                No images available
              </Text>
            )}
          </div>
        </LeftWrapper>

        <RightWrapper>
        <CloseContainer onClick={() => setIsModalOpen(true)}>
  <CloseBackground src={SmallXContainer} alt="Close Container" />
  <CloseXIcon src={SmallX} alt="X Icon" />
</CloseContainer>

          <LoosingProgressModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          castleId={castleId}
        />

          <ContentWrapper>
            <Text
              fontFamily="Manrope"
              fontWeight="400"
              fontSize="16px"
              lineheight="21.86px"
            >
              Μέρος 2ο
            </Text>
            <Text
              fontFamily="'Source Serif 4', serif"
              fontWeight="700"
              fontSize="40px"
              lineheight="54.84px"
            >
              {castleName}
            </Text>

            <UpperWrapper className="upper-wrapper2">
              {/* <InfoWrapper className="info-wrapper2">
                <RowItems>
                  <Icon
                    src={LocationIcon}
                    alt=""
                    iconWidth="13px"
                    iconHeight="16px"
                  />
                  <Text
                    fontFamily="Manrope"
                    fontWeight="400"
                    fontSize="16px"
                    lineheight="21.86px"
                    color={"var(--text-light)"}
                  >
                    {castleLocation}
                  </Text>
                </RowItems>
                <RowItems>
                  <Icon
                    src={TimeIcon}
                    alt=""
                    iconWidth="15px"
                    iconHeight="15px"
                  />
                  <Text
                    fontFamily="Manrope"
                    fontWeight="400"
                    fontSize="16px"
                    lineheight="21.86px"
                    color={"var(--text-light)"}
                  >
                    {castleYear}
                  </Text>
                </RowItems>
                <RowItems>
                  <Icon src={SwordsIcon} alt="" />
                  <Text
                    fontSize="16px"
                    fontFamily="Manrope"
                    fontWeight="400"
                    lineheight="100%"
                    color={"var(--text-light)"}
                  >
                    {castleEvents}
                  </Text>
                </RowItems>
              </InfoWrapper> */}

              
            </UpperWrapper>

            <TextWrapper>
              <DescriptionWrapper>
                <StyledSimpleBar>
  <Text
    fontFamily="Manrope"
    fontWeight="400"
    fontSize="15px"
    lineheight="20px"
    color="var(--text-light)"
    padding="18px 9px"
    textalign="left"
  >
    {description}
  </Text>
</StyledSimpleBar>

              </DescriptionWrapper>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  justifyContent: "space-between",
                  marginTop: "35px",
                  alignItems: "center",
                  flex: "1 1 0%",
                }}
              >
                {audioReady && (
              <Audio step="2" sendDataToParent={handleDataFromChild}  selectedDifficulty={selectedDifficulty}/>

            )}

          <Button
            imgurl={PlayImg}
            onClick={() => {
              console.log(
                `🔁 Navigating to quiz (Part 2) with Castle ID: ${castleId}, Difficulty: ${selectedDifficulty}, Set: set_2`
              );

              setTimeout(() => {
                navigate("/quiz", {
                  state: {
                    castleId,
                    selectedDifficulty,
                    quizSet: "set_2", // ✅ NEW!
                  },
                });
              }, 300);
            }}
          ></Button>

              </div>
            </TextWrapper>

            {/* <SidePageIcon src={Pageside} alt="" /> */}
          </ContentWrapper>
        </RightWrapper>
      </CastlePageWrapper>
    </>
  );
};

export default CastleDetailsPart2;
